import SummaryCard from '@UI/Pages/Administration/AiCosts/CostSummary/SummaryCard';
import aiCostsFiltersSignal from '@UI/Pages/Administration/AiCosts/Filters/Signals/aiCostsFiltersSignal';
import type * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';

type Props = {
	readonly accountId: number;
};

/**
 * The reader is keyed by the summary's query key, so each period and scope gets a fresh read: its
 * first render is always a skeleton, never the previous combination's figures.
 */
const CostSummary: React.FC<Props> = ({ accountId }) => {
	const filters = useSignalValue(aiCostsFiltersSignal);
	const queryKey = filters.summaryQueryParams.toString();

	return <SummaryCard key={queryKey} accountId={accountId} filters={filters} />;
};

export default CostSummary;
